/** Order matches `DPATAssessmentSheet` indicator blocks (Annex 1 → Annex 2 → Annex 3). */
export const DPAT_SHEET_PAGE_LABELS = [
  "Annex 1 — General Assembly meetings",
  "Annex 1 — AAP budget approval",
  "Annex 1 — Sub-structure meetings",
  "Annex 1 — Executive Committee (ECA)",
  "Annex 1 — Sub-statutory committees",
  "Annex 1 — Management meetings",
  "Annex 1 — PRCC meetings",
  "Annex 1 — Entity Tender Committee (ETC)",
  "Annex 1 — SPC / tender committee",
  "Annex 1 — Internal audit unit",
  "Annex 1 — Audit Committee meetings",
  "Annex 1 — Client service functionality",
  "Annex 1 — AAP publication",
  "Annex 1 — Auditor General / GA",
  "Annex 1 — Town hall meetings",
  "Annex 2 — GA decisions (service delivery)",
  "Annex 2 — GA management actions",
  "Annex 2 — GA support / ceded revenue",
  "Annex 2 — Water services",
  "Annex 2 — Electricity services",
  "Annex 2 — Sanitation services",
  "Annex 2 — Maintenance & infrastructure",
  "Annex 2 — Client service charter",
  "Annex 2 — Transportation network",
  "Annex 2 — Building inspectorate unit",
  "Annex 2 — Permit processing & issuance",
  "Annex 2 — Street naming",
  "Annex 2 — Social protection services",
  "Annex 2 — District hotline",
  "Annex 2 — PWD services",
  "Annex 2 — Gender mainstreaming",
  "Annex 2 — Nutrition intervention",
  "Annex 2 — Sanitation service providers",
  "Annex 2 — Dumping sites",
  "Annex 2 — Food vendors",
  "Annex 2 — Public school facilities",
  "Annex 2 — Climate change intervention",
  "Annex 2 — District LED activity plan",
  "Annex 2 — Business & job promotion",
  "Annex 2 — Agro-processing facility support",
  "Annex 2 — Business community engagement",
  "Annex 3 — AAP implementation",
  "Annex 3 — Monitoring projects & activities",
  "Annex 3 — Contract management & administration",
  "Annex 3 — Follow-up on deductions",
  "Annex 3 — Environmental & social safeguards",
  "Annex 3 — Rateable revenue",
  "Annex 3 — Audit Committee responsiveness",
  "Annex 3 — Audit infractions",
  "Annex 3 — Education service support",
  "Annex 3 — Health service support",
  "Annex 3 — Agriculture support",
];

export const DPAT_SHEET_PAGE_COUNT = DPAT_SHEET_PAGE_LABELS.length;
